export const PORTAL_LISTING_PAGE_SIZE = 50;

export const PORTAL_HOME_SECTION_LIMIT = 9;

export const PORTAL_TOPIC_PAGE_SIZE = 50;

export const PORTAL_STORIES_PAGE_SIZE = 25;
